import { useMemo } from 'react';
import { CellContext } from '@tanstack/react-table';

import { DisplayModes } from 'services/webedi/types';
import { EMPTY_FUNCTION } from 'support/helpers/const/const';
import { ColumnTypesInternal, WebEDIRowData } from 'support/types/webediTable';

type Row = CellContext<WebEDIRowData, unknown>['row'];
type Column = CellContext<WebEDIRowData, unknown>['column'];
type Table = CellContext<WebEDIRowData, unknown>['table'];

export const useIsHighlighted = (row: Row, column: Column, displayMode: DisplayModes, table: Table): boolean => {
  const globalFilter = table.getState().globalFilter;
  return useMemo(() => {
    const globalFilterFn = table.getGlobalFilterFn();
    const isHighlightedDisabled = [
      (displayMode === DisplayModes.create || displayMode === DisplayModes.edit) && 'select',
      (displayMode === DisplayModes.create || displayMode === DisplayModes.edit) && 'date',
      ColumnTypesInternal.procuros_delete,
      ColumnTypesInternal.procuros_select,
    ].includes(column.columnDef.meta?.type as string);

    return Boolean(
      !isHighlightedDisabled && globalFilter && globalFilterFn?.(row, column.id, globalFilter, EMPTY_FUNCTION),
    );
  }, [displayMode, globalFilter, column.columnDef.meta?.type, column.id, row, table]);
};
